import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ConfirmDialogComponent } from '../../common/confirm-dialog/confirm-dialog.component';
import { DialogMessageTypes, MessageDialogComponent } from '../../common/message-dialog/message-dialog.component';
import { ProcessingDialogComponent } from '../../common/processing-dialog/processing-dialog.component';
import { SPControllerService } from '../../../services/student-portal/sp-controller-service';
import { StudentTypesService } from '../../../services/student-types-service';
import { OnlineApplication } from '../../../models/student-models/online-application';
import { ResponseObject } from '../../../models/response-object';
import { ResponseStatus } from '../../enums/response-statuses';
import { VwStudentPointsService } from '../../../services/exams-services/vw-student-points-service';

@Component({
  selector: 'app-online-application-form',
  templateUrl: './online-application-form.component.html',
  styleUrls: ['./online-application-form.component.scss']
})
export class OnlineApplicationFormComponent implements OnInit {

  genderDatasource = [{ "Gender": "Female" }, { "Gender": "Male" }];
  yearsDatasource: Years[] = [];
  @ViewChild(MessageDialogComponent, { static: true }) messageDialog: MessageDialogComponent;
  @ViewChild(ProcessingDialogComponent, { static: true }) processingDialog: ProcessingDialogComponent;
  @ViewChild(ConfirmDialogComponent, { static: true }) confirmDialog: ConfirmDialogComponent
  classGroups;
  studentTypesDatasource = this.studentTypesService.oDataSource;
  documentsUpload: Boolean = false;
  documetsDataSource: DocumentsToUpload[] = [];
  uploadDocumentRecord: DocumentsToUpload = new DocumentsToUpload();
  files: any[] = [];
  @ViewChild('fileControl') fileInput: ElementRef;
  isUploadDocumentPopupVisible: Boolean = false;
  record: OnlineApplication = new OnlineApplication();
  contactDatasource = [{ "Type": "Student" }, { "Type": "Next Of Kin" }, { "Type": "Father" }, { "Type": "Mother" }];
  maxDate: Date = new Date();
  isViewApplicationPopupVisible: Boolean = false;
  viewRecord: OnlineApplicationDetails = new OnlineApplicationDetails();
  isFindApplicationPopupVisible: Boolean = false;
  findApplicationRecord: OnlineApplication = new OnlineApplication();

  constructor(private controllerService: SPControllerService,
    private vwStudentPointsService: VwStudentPointsService,
    private studentTypesService: StudentTypesService) {
    this.uploadDocument = this.uploadDocument.bind(this);
  }

  ngOnInit(): void {
    this.controllerService.utilitiesGet("ClassGroups/GetClassGroups").subscribe(
      data => {
        this.classGroups = data;
      }
    )

    this.controllerService.utilitiesGet("OnlineApplicationsRequiredDocuments/GetDocumentTypes").subscribe(
      data => {
        let documentTypes = data;
        this.documetsDataSource = [];
        documentTypes.forEach(element => {
          let requiredDucument: DocumentsToUpload = new DocumentsToUpload();
          requiredDucument.DocumentType = element.DocumentType;
          requiredDucument.DocumentTypeID = element.ID;
          requiredDucument.File = "";
          requiredDucument.FileType = "";
          requiredDucument.FileDetails = [];
          this.documetsDataSource.push(requiredDucument);
        });
        if (this.documetsDataSource.length > 0) {
          this.documentsUpload = true;
        }
      }
    )

    let now = new Date();
    let termYear1: Years = new Years();
    let termYear2: Years = new Years();
    termYear1.year = now.getFullYear().toString();
    this.yearsDatasource.push(termYear1);
    termYear2.year = (now.getFullYear() + 1).toString();
    this.yearsDatasource.push(termYear2);
    this.record = new OnlineApplication();
    this.record.PrimaryContact = "Student";
  }

  onRowPrepared(e) {
    if (e.rowType == 'data' && e.data.File == "") {
      e.rowElement.style.color = 'red';
    }
    else {
      e.rowElement.style.color = 'black';
    }
  }

  uploadDocument(e) {
    this.uploadDocumentRecord = new DocumentsToUpload();
    this.uploadDocumentRecord.DocumentType = e.row.data.DocumentType;
    this.files = [];
    this.fileInput.nativeElement.value = '';
    this.isUploadDocumentPopupVisible = true;
  }

  uploadDocumentCloseClick() {
    this.isUploadDocumentPopupVisible = false;
  }

  getFileDetails(e) {
    this.files = [];
    for (var i = 0; i < e.target.files.length; i++) {
      this.files.push(e.target.files[i]);
    }
  }

  addSelectedDocumentClick() {
    if (this.files == undefined || this.files.length == 0) {
      this.messageDialog.show("Select the file to upload.", DialogMessageTypes.Information);
    }
    else {
      this.uploadDocumentRecord.FileDetails = this.files;
      this.uploadDocumentRecord.File = this.files[0].name;
      this.uploadDocumentRecord.FileDetails = this.files;

      var index = this.documetsDataSource.findIndex(x => x.DocumentType == this.uploadDocumentRecord.DocumentType);
      this.documetsDataSource[index].FileDetails = this.uploadDocumentRecord.FileDetails;
      this.documetsDataSource[index].File = this.uploadDocumentRecord.File;
      this.documetsDataSource[index].FileDetails = this.uploadDocumentRecord.FileDetails;
      this.isUploadDocumentPopupVisible = false;
    }
  }

  submitApplicationClick() {
    if (this.record.Name == undefined || this.record.Name == "") {
      this.messageDialog.show("Provide first name.", DialogMessageTypes.Information);
    }
    else if (this.record.Surname == undefined || this.record.Surname == "") {
      this.messageDialog.show("Provide surname.", DialogMessageTypes.Information);
    }
    else if (this.record.DateOfBirth == undefined) {
      this.messageDialog.show("Provide date of birth.", DialogMessageTypes.Information);
    }
    else if (this.record.Gender == undefined) {
      this.messageDialog.show("Select gender.", DialogMessageTypes.Information);
    }
    else if (this.record.StudentType == undefined || this.record.StudentType == "") {
      this.messageDialog.show("Select student type.", DialogMessageTypes.Information);
    }
    else if (this.record.ClassGroupID == undefined) {
      this.messageDialog.show("Provide class.", DialogMessageTypes.Information);
    }
    else if (this.record.Year == undefined) {
      this.messageDialog.show("Select class year.", DialogMessageTypes.Information);
    }
    else if (this.record.NextOfKin == undefined || this.record.NextOfKin == "") {
      this.messageDialog.show("Provide next of kin.", DialogMessageTypes.Information);
    }
    else if (this.record.MobileNumber == undefined || this.record.MobileNumber == "") {
      this.messageDialog.show("Provide next of kin mobile number.", DialogMessageTypes.Information);
    }
    else if (this.record.MotherFullName == undefined || this.record.MotherFullName == "") {
      this.messageDialog.show("Provide mother's full name.", DialogMessageTypes.Information);
    }
    else if (this.record.FatherFullName == undefined || this.record.FatherFullName == "") {
      this.messageDialog.show("Provide father's full name.", DialogMessageTypes.Information);
    }
    else if (this.record.PrimaryContact == "Student" && (this.record.StudentEmailAddress == undefined || this.record.StudentEmailAddress == "")) {
      this.messageDialog.show("You have selected primary contact as the student so the student's email address is required.", DialogMessageTypes.Information);
    }
    else if (this.record.PrimaryContact == "Next Of Kin" && (this.record.EmailAddress == undefined || this.record.EmailAddress == "")) {
      this.messageDialog.show("You have selected primary contact as the next of kin so the next of kin's email address is required.", DialogMessageTypes.Information);
    }
    else if (this.record.PrimaryContact == "Mother" && (this.record.MotherEmailAddress == undefined || this.record.MotherEmailAddress == "")) {
      this.messageDialog.show("You have selected primary contact as mother so the mother's email address is required.", DialogMessageTypes.Information);
    }
    else if (this.record.PrimaryContact == "Father" && (this.record.FatherEmailAddress == undefined || this.record.FatherEmailAddress == "")) {
      this.messageDialog.show("You have selects primary contact as father so the father's email address is required.", DialogMessageTypes.Information);
    }
    else {
      let allDocumentsUploaded: Boolean = true;
      this.documetsDataSource.forEach(document => {
        if (document.File == "") {
          allDocumentsUploaded = false;
        }
      })

      if (allDocumentsUploaded == false) {
        this.messageDialog.show("Provide all the required documents before submitting the application.", DialogMessageTypes.Information);
      }
      else {
        this.confirmDialog.show("Submit Application", "Are you sure you want to submit this application?");
      }
    }
  }

  confirmClick() {
    this.confirmDialog.hide();
    this.processingDialog.show();
    console.log(this.record)
    this.controllerService.utilitiesPost("OnlineApplications/SaveApplication", this.record).subscribe(
      data => {
        this.processingDialog.hide();
        let response: ResponseObject = data;
        if (response.Status == ResponseStatus.Success) {
          this.documetsDataSource.forEach(item => {
            const frmData = new FormData();
            for (var i = 0; i < item.FileDetails.length; i++) {
              frmData.append("fileUpload", item.FileDetails[i]);
            }
            this.controllerService.utilitiesPost("OnlineApplications/UploadApplicationDocuments?documentTypeID=" + item.DocumentTypeID + "&applicationID=" + response.EntityID, frmData).subscribe(
              data => { }
            )
          })
          this.messageDialog.show(response.StatusDescription, DialogMessageTypes.Information);
        }
        else if (response.Status == ResponseStatus.Failure) {
          this.messageDialog.show(response.StatusDescription, DialogMessageTypes.Information);
        }
        else {
          this.messageDialog.show("A system error was encountered submitting the application, try again later.", DialogMessageTypes.SystemError);
        }
      },
      error => {
        this.processingDialog.hide();
        this.messageDialog.show("A system error was encountered submitting the application, try again later.", DialogMessageTypes.SystemError);
      }
    )
  }

  searchApplicationsClick() {
    this.findApplicationRecord = new OnlineApplication();
    this.isFindApplicationPopupVisible = true;
  }

  findApplicationClick() {
    if (this.findApplicationRecord.Reference == undefined || this.findApplicationRecord.Reference == "") {
      this.messageDialog.show("Provide the reference number for the application you want to view.", DialogMessageTypes.Information);
    }
    else {
      this.processingDialog.show();
      this.vwStudentPointsService.searchNonOdata("VwOnlineApplications?$filter=Reference eq '" + this.findApplicationRecord.Reference + "'").subscribe(
        data => {
          this.processingDialog.hide();
          if (data.value.length == 0) {
            this.messageDialog.show("No application record was found with reference '" + this.findApplicationRecord.Reference + "', verify the reference and search again.", DialogMessageTypes.Information);
          }
          else {
            this.viewRecord = data.value[0];
            this.isFindApplicationPopupVisible = false;
            this.isViewApplicationPopupVisible = true;
          }
        },
        error => {
          this.processingDialog.hide();
          this.messageDialog.show("A system error was encountered processing your request, try again later.", DialogMessageTypes.SystemError);
        }
      );
    }
  }

  findApplicationCloseClick() {
    this.isFindApplicationPopupVisible = false;
  }

  closeViewApplicationPopUpClick() {
    this.isViewApplicationPopupVisible = false;
  }
}

export class Years {
  public year: String;
}

class DocumentsToUpload {
  public DocumentTypeID: Number;
  public DocumentType: String;
  public File: String;
  public FileType: String;
  public FileDetails: any[] = [];
}

class OnlineApplicationDetails {
  public Reference: String;
  public Name: String;
  public Surname: String;
  public Gender: String;
  public DateOfBirth: Date;
  public IDNumber: String;
  public Nationality: String;
  public Religion: String;
  public PreviousSchool: String;
  public StudentEmailAddress: String;
  public StudentMobileNumber: String;
  public ClassGroup: String;
  public Year: String;
  public StudentType: String;
  public Address: String;
  public NextOfKin: String;
  public Relationship: String;
  public MobileNumber: String;
  public EmailAddress: String;
  public MotherFullName: String;
  public MotherMobileNumber: String;
  public MotherEmailAddress: String;
  public FatherFullName: String;
  public FatherMobileNumber: String;
  public FatherEmailAddress: String;
  public PrimaryContact: String;
  public Status: String;
  public Comment: String;
}

